const RETIRED_FLEXLAYOUT_PREFERENCE_KEYS = ["custom_layout", "editor_layout"];

export function preferencesForRemoteSync(preferences) {
  if (!preferences || typeof preferences !== "object" || Array.isArray(preferences)) {
    return {};
  }

  const remotePreferences = { ...preferences };
  RETIRED_FLEXLAYOUT_PREFERENCE_KEYS.forEach(key => {
    delete remotePreferences[key];
  });

  return remotePreferences;
}
